export default __webpack_public_path__ + "static/media/surgeon.847bfa39.jpg";